import { Devices, Spacings, Text } from '@styles'

const { PageLevelTableWrapper, Table, BaseWrapper, H3 } = require('@base')
const { HeaderRow, InnerRowWrapper, HeaderCell, Cell } = require('@base/composite/Table/Table')
const { default: styled } = require('styled-components')

export const Wapper = styled(BaseWrapper)`
	display: flex;
	width: 100%;
	padding: ${Spacings.SPACING_4B};
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
	font-family: 'Poppins', sans-serif;
	* {
		font-family: Poppins !important;
	}
`

export const HeaderWapper = styled.div`
	display: flex;
	flex-direction: column;
	font-size: ${Text.X_LARGE};
	gap: ${Spacings.SPACING_4B};
	align-items: flex-start;
	line-height: ${Text.LINE_HEIGHT_MAX};
	justify-content: ${({ JustifyStart }) => (JustifyStart ? 'flex-start' : 'space-between')};
	margin-bottom: ${Spacings.SPACING_3B};
	border-bottom: none;
	@media ${Devices.mobile} {
		flex-direction: row;
		align-items: center;
	}
`

export const Heading = styled(H3)`
	color: var(--Cool-Gray-90, ${({ theme }) => theme.palette.text.greySeven});
	font-family: Poppins;
	font-size: ${Text.X_LARGE};
	font-style: normal;
	font-weight: ${Text.BOLD_500};
	line-height: ${Spacings.SPACING_7B}; /* 140% */
`

export const TableContainer = styled(PageLevelTableWrapper)`
	border-radius: 0.625rem;
	border: 1px solid var(--Cool-Gray-20, ${({ theme }) => theme.palette.text.greyFive});
	background: ${({ theme }) => theme.palette.background.white};

	${Cell} {
		color: var(--Cool-Gray-100, #0d1016);

		/* 14 - Body 4/Regular */
		font-family: Poppins;
		font-size: 0.875rem;
		font-style: normal;
		font-weight: 400;
		line-height: 1.375rem; /* 157.143% */
	}

	${HeaderCell} {
		overflow: hidden;
		color: var(--Cool-Gray-70, ${({ theme }) => theme.palette.text.greyFour});
		font-family: Poppins;
		font-size: ${Text.MEDIUM};
		font-style: normal;
		font-weight: ${Text.BOLD_400};
		line-height: 1.375rem;
	}

	${HeaderRow} {
		border-bottom: 1px dashed var(--Cool-Gray-20, ${({ theme }) => theme.palette.text.greyFive});
	}
	${InnerRowWrapper} {
		border-bottom: none;
	}
`
export const TableWapper = styled(Table)`
	min-height: 28rem;
`
